import React from "react";

export function Gallery() {
  return (
    <section className="px-6 md:px-10 py-16 text-center">
      <h2 className="text-3xl mb-6">Gallery</h2>
      <p className="text-sm">Project imagery coming soon.</p>
    </section>
  );
}
